import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import Styles from './styles.module.scss';

const cx = classNames.bind(Styles);

const Tabs = ({
  tabs = [],
  value,
  onChange,
  className = '',
}) => (
  <ul className={cx('tabs', className)}>
    {tabs.map((tab) => (
      <li
        key={tab.value}
        className={cx('tab', {
          selected: tab.value === value,
        })}
        onClick={tab.value !== value ? () => onChange(tab.value) : undefined}
      >
        {tab.label}
      </li>
    ))}
  </ul>
);

Tabs.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
      ]).isRequired,
      label: PropTypes.node.isRequired,
    }),
  ).isRequired,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]).isRequired,
  onChange: PropTypes.func.isRequired,
};

export default Tabs;
